import parseJwt from '../../assets/Js/jwtParse';

export const setToken = (token, expries) => {
    localStorage.setItem('token', token);
    localStorage.setItem('expires', expries);
}

export const deleteToken = () => {
    localStorage.setItem("token", "");
    localStorage.setItem("expires", "");
}

export const getToken = () => {
    return parseJwt(localStorage.getItem("token"));
}

export const getPlainToken = () => {
    return localStorage.getItem("token");
}

export const getExpiryTime = () => {
    return localStorage.getItem("expires");
}

export const setUserData = (userData) => {
    return localStorage.setItem("userData", JSON.stringify(userData));
}

export const getUserData = () => {
    return JSON.parse(localStorage.getItem("userData"));
}